<template>
  <div class="vx-col w-full">
    <vx-card title="Applicant Contact Information">
      <br>
      <form data-vv-scope="contact">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Mobile (মোবাইল  নং )</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" disabled type="number" v-model="contact.mobile"/>
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Other Phone(অন্য ফোন নং )</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <!--<vs-input class="w-full" type="number" v-model="contact.otherPhone"/>-->
                <vs-input
                  type="tel"
                  v-validate="'min:11|max:11'"
                  data-vv-validate-on="blur"
                  name="contact.otherPhone"
                  placeholder="Other Phone"
                  v-model="contact.otherPhone"
                  @keypress="onlyNumber"
                  data-vv-as="Other Phone"
                  class="w-full"/>
                <span class="text-danger text-sm" v-show="errors.has('contact.otherPhone')">{{ errors.first('contact.otherPhone') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full mt-2">
                <span>Email (ই-মেইল )</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-validate="'email'" data-vv-as="Email" type="email"
                          v-model="contact.email" name="contact.email"/>
                <span class="text-danger text-sm" v-show="errors.has('contact.email')">{{ errors.first('contact.email') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
              <vx-card title="Present Address">

                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Division (বিভাগ)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select label="name" v-model="contact.tDevision" class="w-full select-large"
                                v-validate="'required'" data-vv-as="Division" name="contact.tDevision"
                                :options="divisionJson"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('contact.tDevision')">{{ errors.first('contact.tDevision') }}</span>
                  </div>
                </div>
                <div v-if="contact.tDevision" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>District (জেলা)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select label="name" v-model="contact.tDistrict" class="w-full select-large"
                                v-validate="'required'" data-vv-as="District" name="contact.tDistrict"
                                :options="districtJson.filter(dist => dist.division_id === contact.tDevision.id)"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('contact.tDistrict')">{{ errors.first('contact.tDistrict') }}</span>
                  </div>
                </div>
                <div v-if="contact.tDistrict" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Thana (থানা)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select label="name" v-model="contact.tThana" class="w-full select-large"
                                v-validate="'required'" data-vv-as="Thana" name="contact.tThana"
                                :options="thanas.filter(tThana => tThana.district_id === contact.tDistrict.id)"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('contact.tThana')">{{ errors.first('contact.tThana') }}</span>
                  </div>
                </div>
                <div v-if="contact.tThana" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Apt#/House#/Road#/Village# (এ্যাপার্টমেন্ট/বাসা/সড়ক নং/গ্রাম )<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="contact.tAptHouseRoadVill"
                              v-validate="'required'" data-vv-as="Apt#/House#/Road#/Village#"
                              name="contact.tAptHouseRoadVill"/>
                    <span class="text-danger text-sm" v-show="errors.has('contact.tAptHouseRoadVill')">{{ errors.first('contact.tAptHouseRoadVill') }}</span>
                  </div>
                </div>
                <div v-if="contact.tAptHouseRoadVill" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Nearby Famous Landmark (কাছাকাছি বিখ্যাত ল্যান্ডমার্ক)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="contact.tNearByLandmark" v-validate="'required'"
                              data-vv-as="Nearby Famous Landmark" name="contact.tNearByLandmark"/>
                    <span class="text-danger text-sm" v-show="errors.has('contact.tNearByLandmark')">{{ errors.first('contact.tNearByLandmark') }}</span>
                  </div>
                </div>
                <div v-if="contact.tNearByLandmark" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Postal code (ডাকঘর  নং)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" @keypress="onlyNumber" v-model="contact.tPostalCode"
                              v-validate="'required|min:4|max:4'" data-vv-as="Postal code" name="contact.tPostalCode"/>
                    <span class="text-danger text-sm" v-show="errors.has('contact.tPostalCode')">{{ errors.first('contact.tPostalCode') }}</span>
                  </div>
                </div>
                <div v-if="contact.tPostalCode" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Household Type (গৃহস্থালি প্রকার)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <ul class="demo-alignment">
                      <li class="mt-0">
                        <vs-radio v-model="contact.tHouseHoldType" vs-value="tOwnResident" v-validate="'required'"
                                  data-vv-as="Household Type" name="contact.tHouseHoldType">Own Resident
                        </vs-radio>
                      </li>
                      <li class="mt-0">
                        <vs-radio v-model="contact.tHouseHoldType" vs-value="tRented" v-validate="'required'"
                                  data-vv-as="Household Type" name="contact.tHouseHoldType">Rented
                        </vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger text-sm" v-show="errors.has('contact.tHouseHoldType')">{{ errors.first('contact.tHouseHoldType') }}</span>
                  </div>
                </div>
                <div v-if="contact.tHouseHoldType" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Living in this address (কতদিন এই ঠিকানায় আছেন?)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div class="demo-alignment">
                      <vx-input-group class="mb-base">
                        <template slot="prepend">
                          <div class="prepend-text bg-primary">
                            <span>Year</span>
                          </div>
                        </template>
                        <vs-input class="mt-0" type="text" @keypress="onlyNumber" v-model="contact.tLeavingYear"
                                  placeholder="Year"/>
                      </vx-input-group>

                      <template>
                        <vx-input-group class="mb-base">
                          <template slot="prepend">
                            <div class="prepend-text bg-primary">
                              <span>Month</span>
                            </div>
                          </template>
                          <v-select v-model="contact.tLeavingMonth" class="select-large mt-0" style="width:120px"
                                    v-validate="'required'" data-vv-as="Living in this address"
                                    name="contact.tLeavingMonth"
                                    placeholder="Months" :options="jobLengthArr"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                        </vx-input-group>
                      </template>
                      <span class="text-danger text-sm" v-show="errors.has('contact.tLeavingMonth')">{{ errors.first('contact.tLeavingMonth') }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="contact.tLeavingMonth > 0 || contact.tLeavingYear > 0" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/1 w-full">
                    <vs-checkbox vs-value="Luis Daniel" v-model="sameAssPresent" @change="sameAsAddress">Parmanent address: same as Present address
                    </vs-checkbox>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="vx-col w-full">
              <vx-card title="Permanent Address">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Division (বিভাগ)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select :disabled="sameAssPresent === true" label="name" v-model="contact.pDevision"
                                class="w-full select-large" v-validate="'required'" data-vv-as="Division"
                                name="contact.pDevision"
                                :options="divisionJson"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('contact.pDevision')">{{ errors.first('contact.pDevision') }}</span>
                  </div>
                </div>
                <div v-if="contact.pDevision" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>District  (জেলা)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select :disabled="sameAssPresent === true" label="name" v-model="contact.pDistrict"
                                class="w-full select-large" v-validate="'required'" data-vv-as="District"
                                name="contact.pDistrict"
                                :options="districtJson.filter(pDist => pDist.division_id === contact.pDevision.id)"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('contact.pDistrict')">{{ errors.first('contact.pDistrict') }}</span>
                  </div>
                </div>
                <div v-if="contact.pDistrict" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Thana  (থানা)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select :disabled="sameAssPresent === true" label="name" v-model="contact.pThana"
                                class="w-full select-large" v-validate="'required'" data-vv-as="Thana"
                                name="contact.pThana"
                                :options="thanas.filter(pThana => pThana.district_id === contact.pDistrict.id)"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                    <span class="text-danger text-sm" v-show="errors.has('contact.pThana')">{{ errors.first('contact.pThana') }}</span>
                  </div>
                </div>
                <div v-if="contact.pThana" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Apt#/House#/Road#/Village# (এ্যাপার্টমেন্ট/বাসা/সড়ক নং/গ্রাম )<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input :disabled="sameAssPresent === true" class="w-full" type="text"
                              v-model="contact.pAptHouseRoadVill" v-validate="'required'"
                              data-vv-as="Apt#/House#/Road#/Village#" name="contact.pAptHouseRoadVill"/>
                    <span class="text-danger text-sm" v-show="errors.has('contact.pAptHouseRoadVill')">{{ errors.first('contact.pAptHouseRoadVill') }}</span>
                  </div>
                </div>
                <div v-if="contact.pAptHouseRoadVill" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Nearby Famous Landmark (কাছাকাছি বিখ্যাত ল্যান্ডমার্ক)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input :disabled="sameAssPresent === true" class="w-full" type="text"
                              v-model="contact.pNearByLandmark" v-validate="'required'"
                              data-vv-as="Nearby Famous Landmark" name="contact.pNearByLandmark"/>
                    <span class="text-danger text-sm" v-show="errors.has('contact.pNearByLandmark')">{{ errors.first('contact.pNearByLandmark') }}</span>
                  </div>
                </div>
                <div v-if="contact.pNearByLandmark" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Postal code (ডাকঘর  নং)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input :disabled="sameAssPresent === true" class="w-full" type="text"
                              @keypress="onlyNumber"
                              v-model="contact.pPostalCode" v-validate="'required|min:4|max:4'" data-vv-as="Postal code"
                              name="contact.pPostalCode"/>
                    <span class="text-danger text-sm" v-show="errors.has('contact.pPostalCode')">{{ errors.first('contact.pPostalCode') }}</span>
                  </div>
                </div>
                <div v-if="contact.pPostalCode" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Household Type (গৃহস্থালি প্রকার)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <ul class="demo-alignment">
                      <li class="mt-0">
                        <vs-radio :disabled="sameAssPresent === true" v-model="contact.pHouseHoldType"
                                  vs-value="pOwnResident" v-validate="'required'" data-vv-as="Household Type"
                                  name="contact.pHouseHoldType">Own Resident
                        </vs-radio>
                      </li>
                      <li class="mt-0">
                        <vs-radio :disabled="sameAssPresent === true" v-model="contact.pHouseHoldType"
                                  vs-value="pRented" v-validate="'required'" data-vv-as="Household Type"
                                  name="contact.pHouseHoldType">Rented
                        </vs-radio>
                      </li>
                    </ul>
                    <span class="text-danger text-sm" v-show="errors.has('contact.pHouseHoldType')">{{ errors.first('contact.pHouseHoldType') }}</span>
                  </div>
                </div>
                <div v-if="contact.pHouseHoldType" class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Living in this address (কতদিন এই ঠিকানায় আছেন?)<sup>*</sup></span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div class="demo-alignment">
                      <vx-input-group class="mb-base">
                        <template slot="prepend">
                          <div class="prepend-text bg-primary">
                            <span>Year</span>
                          </div>
                        </template>
                        <vs-input :disabled="sameAssPresent === true" class="mt-0" type="text" @keypress="onlyNumber" width="20"
                                  v-model="contact.pLeavingYear" placeholder="Year"/>
                      </vx-input-group>
                      <template>
                        <vx-input-group class="mb-base">
                          <template slot="prepend">
                            <div class="prepend-text bg-primary">
                              <span>Month</span>
                            </div>
                          </template>
                          <v-select :disabled="sameAssPresent === true" v-model="contact.pLeavingMonth" class="select-large mt-0" style="width:120px"
                                    placeholder="Months" :options="jobLengthArr" v-validate="'required'"
                                    data-vv-as="Living in this address" name="contact.pLeavingMonth"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                        </vx-input-group>
                      </template>
                      <span class="text-danger text-sm" v-show="errors.has('contact.pLeavingYear')">{{ errors.first('contact.pLeavingYear') }}</span>
                      <span class="text-danger text-sm" v-show="errors.has('contact.pLeavingMonth')">{{ errors.first('contact.pLeavingMonth') }}</span>
                    </div>
                  </div>
                </div>
              </vx-card>
              <br>
              <div class="vx-row">
                <div class="vx-col w-full text-right">
                  <vs-button color="success" class="mr-3 mb-2 float-right" @click="updateContactInfoNoError(contact)">Update
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>
<script>

  import division from '../../assets/utils/division'
  import district from '../../assets/utils/district'
  import upazila from '../../assets/utils/upazila'

  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  import axios from "../../axios";

  export default {
    data () {
      return {
        divisionJson: division.divisions,
        districtJson: district.districts,
        thanas: upazila.upazilas,
        sameAssPresent: false,
        divisionArr: [{
          id: '',
          name: '',
          bn_name: '',
          lat: '',
          long: ''
        }],
        districtArr: [{
          id: '',
          division_id: '',
          name: '',
          bn_name: '',
          lat: '',
          long: ''
        }],
        filteredDist: '',
        userInfo: '',
        contact: {
          id:'',
          ekyc_id:'',
          mobile: '',
          otherPhone: '',
          email: '',
          presentAddId: '',
          tDevision: '',
          tDistrict: '',
          tThana: '',
          tAptHouseRoadVill: '',
          tNearByLandmark: '',
          tPostalCode: '',
          tHouseHoldType: '',
          tLeavingYear: '0',
          tLeavingMonth: '0',
          permanentAddId: '',
          pDevision: '',
          pDistrict: '',
          pThana: '',
          pAptHouseRoadVill: '',
          pNearByLandmark: '',
          pPostalCode: '',
          pHouseHoldType: '',
          pLeavingYear: '0',
          pLeavingMonth: '0',
          tLivingInThisAddress: '',
          pLivingInThisAddress: '',
        },
        occupationDrop: [
          {
            id: 1,
            occuName: 'Government'
          },
          {
            id: 2,
            occuName: 'Non-Government'
          },
          {
            id: 3,
            occuName: 'Teacher'
          }
        ],
        jobLengthArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],

      }
    },

    watch: {

    },
    mounted() {
      //this.$store.dispatch('apiLoading', true);
      axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/getApplicantContactInfo/`+this.$route.params.ekyc_id).then((response)=>{

        console.log("Contact info = ", response);
        if (response.data.length > 0) {
          this.contact.id = response.data[0].id
          this.contact.ekyc_id = response.data[0].ekyc_id
          this.contact.mobile = response.data[0].mobile
          this.contact.otherPhone = response.data[0].other_phone
          this.contact.email = response.data[0].email
          this.contact.presentAddId = response.data[0].present_address.id
          this.contact.tDevision = response.data[0].present_address.division
          this.contact.tDistrict = response.data[0].present_address.district
          this.contact.tThana = response.data[0].present_address.thana
          this.contact.tAptHouseRoadVill = response.data[0].present_address.address
          this.contact.tNearByLandmark = response.data[0].present_address.near_landmark
          this.contact.tPostalCode = response.data[0].present_address.postal_code
          this.contact.tHouseHoldType = response.data[0].present_address.house_hold_type
          var tLeavingArr = response.data[0].present_address.living_in_this_address.split(',')
          this.contact.tLeavingYear = tLeavingArr[0]
          this.contact.tLeavingMonth = tLeavingArr[1]
          this.contact.permanentAddId = response.data[0].permanent_address.id
          this.contact.pDevision = response.data[0].permanent_address.pdivision
          this.contact.pDistrict = response.data[0].permanent_address.pdistrict
          this.contact.pThana = response.data[0].permanent_address.pthana
          this.contact.pAptHouseRoadVill = response.data[0].permanent_address.paddress
          this.contact.pNearByLandmark = response.data[0].permanent_address.pnear_landmark
          this.contact.pPostalCode = response.data[0].permanent_address.ppostal_code
          this.contact.pHouseHoldType = response.data[0].permanent_address.phouse_hold_type
          var pLeavingArr = response.data[0].permanent_address.pliving_in_this_address.split(',')
          this.contact.pLeavingYear = pLeavingArr[0]
          this.contact.pLeavingMonth = pLeavingArr[1]
        }
        this.$store.dispatch('apiLoading', false);
      });
      console.log("mounted", this.$route.params.ekyc_id)

    },
    methods: {
      sameAsAddress () {
        console.log('Same ass')
        this.contact.pDevision = this.contact.tDevision
        this.contact.pDistrict = this.contact.tDistrict
        this.contact.pThana = this.contact.tThana
        this.contact.pAptHouseRoadVill = this.contact.tAptHouseRoadVill
        this.contact.pNearByLandmark = this.contact.tNearByLandmark
        this.contact.pPostalCode = this.contact.tPostalCode
        if (this.contact.tHouseHoldType == 'tOwnResident') {
          this.contact.pHouseHoldType = 'pOwnResident'
        } else {
          this.contact.pHouseHoldType = 'pRented'
        }
        //this.contact.pHouseHoldType =this.contact.tHouseHoldType;
        //this.contact.pLivingInThisAddress = this.contact.tLivingInThisAddress
      },
      updateContactInfoNoError (contact) {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll('contact').then(result => {
            if (result) {
              this.updateContactInfo(contact)
              resolve(true)
            } else {
              reject('correct all values')
            }
          })
        })
      },
      async updateContactInfo (contact) {
        console.log(contact )

        if(typeof contact.pDevision === "object"){
          contact.pDevision = contact.pDevision.name;
        }
        if(typeof contact.pDistrict === "object"){
          contact.pDistrict = contact.pDistrict.name;
        }
        if(typeof contact.pThana === "object"){
          contact.pThana = contact.pThana.name;
        }

        if(typeof contact.tDevision === "object"){
          contact.tDevision = contact.tDevision.name;
        }
        if(typeof contact.tDistrict === "object"){
          contact.tDistrict = contact.tDistrict.name;
        }
        if(typeof contact.tThana === "object"){
          contact.tThana = contact.tThana.name;
        }
        contact.tLivingInThisAddress = this.contact.tLeavingYear + ',' + this.contact.tLeavingMonth || 0,
        contact.pLivingInThisAddress = this.contact.pLeavingYear + ',' + this.contact.pLeavingMonth || 0,
        axios.put(`https://ho.butterflygroupbd.com/showroom-backend/api/updateApplicantContactInfo`, contact).then((response)=>{
          console.log(response );
          this.$vs.notify({
            title: 'Updated',
            text: 'Contact Information Successfully Updated.',
            color: "success",
            position: 'top-right'
          })
          window.history.back();
        }).catch((error) =>{
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: "danger",
            position: 'top-right'
          })
        })
      },
      onlyNumber ($event) {
        //console.log($event.target); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      }
    },
    components: {
      //FormWizard,
      //TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
<style scoped>
  sup {
    font-size: 16px;
    color: red;
  }
</style>
